const emptyHTMLString = "<p>&nbsp;</p>";

export const validateNewsForm = (data) => {
  const errors = {};
  if (!data.title?.trim()) {
    errors.title = "Title is required.";
  }
  if (!data.status?.trim()) {
    errors.status = "Status is required.";
  }
  if (!data.info?.trim() || data.info === emptyHTMLString) {
    errors.info = "Info is required.";
  }
  return errors;
};
